// extracted by mini-css-extract-plugin
export default {"panelHeading":"FunctionPanel_panelHeading__4N8Gi","list":"FunctionPanel_list__p-XAs"};